import { IconType } from '../../constants';
import { extractUrlFromIconJsonLd } from '@atlaskit/link-extractors';
var priorityMapper = {
  blocker: IconType.PriorityBlocker,
  critical: IconType.PriorityCritical,
  high: IconType.PriorityHigh,
  highest: IconType.PriorityHighest,
  low: IconType.PriorityLow,
  lowest: IconType.PriorityLowest,
  major: IconType.PriorityMajor,
  medium: IconType.PriorityMedium,
  minor: IconType.PriorityMinor,
  trivial: IconType.PriorityTrivial,
  undefined: IconType.PriorityUndefined
};
var extractPriority = function extractPriority(data) {
  var priority = data['atlassian:priority'];
  if (priority) {
    if (typeof priority === 'string') {
      var icon = priorityMapper[priority.toLowerCase()];
      if (icon) {
        return {
          icon: icon,
          label: priority
        };
      }
    } else if (priority['@type'] === 'Object') {
      return {
        label: priority.name,
        url: priority.icon && extractUrlFromIconJsonLd(priority.icon)
      };
    }
  }
};
export default extractPriority;